import { render, staticRenderFns } from "./CertificateContent.vue?vue&type=template&id=3da4e6f9&scoped=true&"
import script from "./CertificateContent.vue?vue&type=script&lang=js&"
export * from "./CertificateContent.vue?vue&type=script&lang=js&"
import style0 from "./CertificateContent.vue?vue&type=style&index=0&id=3da4e6f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4e6f9",
  null
  
)

export default component.exports